<script setup lang="ts">
/**
 * QaEnvBanner — a full-width green strip that marks the QA environment, so
 * anyone using qa.rounds.vin / qa.roundstranscripttool.vin can see at a glance
 * that it is safe to test. Matches the qa.po.vin banner.
 *
 * Detection is by hostname (synchronous; the SPA is served same-origin as its
 * API, and QA lives only on the `qa.` subdomains). Production hosts
 * (rounds.vin, roundstranscripttool.vin) and localhost do NOT start with
 * `qa.`, so the bar can never render in production. No backend call and no
 * build flag — QA and production share one build, so a build-time flag could
 * not tell them apart; the runtime host can.
 */
import { computed } from 'vue';

const isQa = computed<boolean>(() => {
  try {
    return window.location.hostname.toLowerCase().startsWith('qa.');
  } catch {
    return false;
  }
});
</script>

<template>
  <div v-if="isQa" class="qa-env-bar" role="status" data-test-id="qa-env-bar">
    QA environment · safe to test
  </div>
</template>

<style>
.qa-env-bar {
  background: #1a8a4c;
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 6px 12px;
  line-height: 1.35;
  border-block-end: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
